import React, { useState, useEffect ,useContext,useRef} from "react";
import { Form, Input, Select, Space, Row, Col, Button, Modal, Table, message, Popconfirm, Tooltip } from "antd";
import UploadFilepic from "./AddSubtenantUser";
import "../../Styles/subtenant.css";
import Services from "../../network/Services";
import konsole from "../../network/konsole";
import AddSubtenantUsers from "./AddSubtenantUsers";
import AddSubtenantNewRoles from "./AddSubtenantNewRoles";
import DeleteConfirmModal from "../DeleteConfirmModal";
import { UserContext } from "../../App";
import { EditOutlined, DeleteOutlined,ProfileFilled,UserOutlined } from "@ant-design/icons";
import { formatPhoneNumberWithoutCntryCode } from "../../control/Constant";
 import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';

const { Option } = Select;
const { Search } = Input;

const SubtenantTable = (props) => {
  const [data, setdata] = useState([]);
  const [visible, setVisible] = useState(false);
  const [file, setFile] = useState("");
  const [subtenantValue, setSubtenantValue] = useState('');
  const [subtenantdata, setsubtenantdata] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);
  const [value, setValue] = useState("");
  const [assignOptionsList, setAssignOptionsList] = useState([]);
  const [show, setshow] = useState(false)
  const [showRolesModal, setShowRolesModal] = useState(false)
  const [selectedSubtenant, setselectedSubtenant] = useState('')
  const [selectedSubtenantUser, setSelectedSubtenantUser] = useState(null);
  const { setLoader } = useContext(UserContext)
  const [roleid, setroleid] = useState('')
  const [defaultvalue,setDefaultvalue]=useState('Select a partner')
  const [disabledselect,setdisableselect]=useState(false)
  const [searchevent, setSearchevent] =useState("");
  const [deactivateModalVisible, setDeactivateModalVisible] = useState(false);
  const [resendInviteModalVisible, setResendInviteModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, order: 'asc' });
  const tableRef = useRef(null);
  const [tableHeight, setTableHeight] = useState('400px');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const paginatedData = (data) => {
    const start = (currentPage - 1) * pageSize;
    return data.slice(start, start + pageSize);
  };

  const totalPages = (data) => Math.ceil(data.length / pageSize);

useEffect(() => {
  const updateHeight = () => {
    if (tableRef.current) {
      const top = tableRef.current.getBoundingClientRect().top;
      const height = window.innerHeight - top - 20; // 20px bottom padding
      setTableHeight(`${height}px`);
    }
  };

  updateHeight(); // run on mount
  window.addEventListener('resize', updateHeight); // run on resize

  return () => window.removeEventListener('resize', updateHeight);
}, []);

  konsole.log("subtenantValue",subtenantValue,selectedSubtenant)



const sortIcon = (key) => {
  if (sortConfig.key !== key) return <FaSort style={{ color: '#aaa', marginLeft: '4px' }} />;
  return sortConfig.order === 'asc'
    ? <FaSortUp style={{ color: '#720c20', marginLeft: '4px' }} />
    : <FaSortDown style={{ color: '#720c20', marginLeft: '4px' }} />;
};


  const showUserModal = () => {
    setUpdatePartnerUsersData()
    setVisible(true);
    setshow(!show);
  };

  const showRolesModalFunc = (record) => {
    setSelectedSubtenantUser(record);
    konsole.log("recordrecord",record)
    // if(record.isActive == false){
    //   message.error("User not activated yet, Please activate the user.")
    // }else {
    //   setShowRolesModal(true);
    // }
    setShowRolesModal(true);
  };

  const hideRolesModalFunc = () => {
    setShowRolesModal(false);
  };

  const openDeactivateModal = (user) => {
  setSelectedUser(user);
  setDeactivateModalVisible(true);
 };

const openResendInviteModal = (user) => {
  setSelectedUser(user);
  setResendInviteModalVisible(true);
 };


  const hideUserModal = () => {
    setVisible(false);
    setshow(false)
  };
  // table//////////////////////////////////////

  const handleSort = (key) => {
  setSortConfig(prev => ({
    key,
    order: prev.key === key && prev.order === 'asc' ? 'desc' : 'asc'
  }));
};

const getSortedData = (data) => {
  if (!sortConfig.key) return data;
  return [...data]?.sort((a, b) => {
    let aVal = a[sortConfig.key];
    let bVal = b[sortConfig.key];
    if (typeof aVal === 'boolean' || typeof bVal === 'boolean') {
      aVal = aVal ? 1 : 0;
      bVal = bVal ? 1 : 0;
      return sortConfig.order === 'asc' ? bVal - aVal : aVal - bVal;
    }
    aVal = (aVal || '').toString().toLowerCase();
    bVal = (bVal || '').toString().toLowerCase();
    if (aVal < bVal) return sortConfig.order === 'asc' ? -1 : 1;
    if (aVal > bVal) return sortConfig.order === 'asc' ? 1 : -1;
    return 0;
  });
};



  // table//////////////////////////////////////

  const onFinish = (values) => {
    konsole.log("Finish:", values);
  };

  const [placement, SetPlacement] = useState("topLeft");

  const placementChange = (e) => {
    SetPlacement(e.target.value);
  };
  const onSelect = (e, option) => {
    konsole.log("key", e);
    konsole.log("option", option);
    setDefaultvalue(option.label);
    setSubtenantValue(e);
    setselectedSubtenant(option.label);
    konsole.log(value);
  };
  konsole.log("subtenantValueee", subtenantValue,selectedSubtenant);
  konsole.log("selectedSubtenantselectedSubtenant",selectedSubtenant)

// const seletedValue=(e)=>{
//   konsole.log("selectedsubt",e)
// }

  useEffect(() => {
    getUserListApi();
  }, [subtenantValue]);



  useEffect(()=>{
    let userroleId=JSON.parse(sessionStorage.getItem("stateObj"))
    let subtenantId=sessionStorage.getItem("subtenantId")
    setroleid(userroleId?.roleId)
    if(subtenantdata !=='' && subtenantdata !==undefined && roleid == "11"){
      setdisableselect(true)
      setSubtenantValue(Number(subtenantId))
      let datafilter=subtenantdata.filter((val)=>{
        return val.subtenantId==subtenantId
      })
      setDefaultvalue(datafilter[0]?.subtenantName)
      setselectedSubtenant(datafilter[0]?.subtenantName)
      konsole.log("datafilterdatafilter",datafilter)

    }else{
      setDefaultvalue(subtenantdata[0]?.subtenantName)

      setSubtenantValue(subtenantdata[0]?.subtenantId);
      setselectedSubtenant(subtenantdata[0]?.subtenantName)
      setdisableselect(false)
    }

  },[subtenantdata])



  const createdBy = null;
  const isActive = true;

  useEffect(() => {
    const Subtenantdetailspromise = Services.getsubtenantdetails(
      createdBy,
      isActive
    );
    Subtenantdetailspromise.then((res) => {
      setsubtenantdata(res.data.data);
    }).catch((err) => {
      konsole.log("err", err);
    });
  }, []);

  const getUserListApi = (startValue, EndValue) => {
    if(startValue !== 1){
      setLoader(true)
    }
    const subtenantId = subtenantValue;
    if(subtenantId !=='' && subtenantId !==undefined && subtenantId !==null){
    konsole.log("subtenantId",subtenantId)

    const getUserlistpromise = Services.getUserList(subtenantId);
    getUserlistpromise
      .then((res) => {
        const roleUserId = sessionStorage.getItem('roleUserId')
        let allData = res.data.data
        if (roleUserId == 4) {
          allData = allData?.filter(x => x?.roleKey?.split(",").some(
                role => role.trim().toLowerCase() === "firm administrator"
              ));
        }
        setdata(allData);
        konsole.log(res.data.data)
        setAssignOptionsList(allData);
        setLoader(false)
        if(startValue !== 1){

          hideUserModal()
        }
        if(startValue == EndValue - 1){

          hideRolesModalFunc()
        }
      })
      .catch((err) => {
        konsole.log("errerr", err);
      }).finally(()=>{
        setLoader(false);
      });
    }
  };
  const onSearch = (value) => konsole.log(value);
  // konsole.log("defaultvaluedefaultvalue",defaultvalue)
  konsole.log("selectedSubtenantUser",selectedSubtenantUser)

  konsole.log("assignOptionsListassignOptionsList",assignOptionsList)


  const searchonchange=()=>{
    let filteredData = [];
    if(searchevent !==null && searchevent !=='' && searchevent !==undefined){
      let filter=data.filter((items)=>{
        let name=items.fullName
        let userName=items.userName
        let mobile=(items.primaryMobile || '').replace(/\D/g,'')
        let searchDigits=searchevent.replace(/\D/g,'')
        return name.toLowerCase().includes(searchevent.toLocaleLowerCase()) ||
        userName.toLowerCase().includes(searchevent.toLocaleLowerCase()) ||
        (searchDigits?.length > 0 && mobile.includes(searchDigits)) ||
        (items.primaryMobile || '').toLowerCase().includes(searchevent.toLowerCase())
      })
      konsole.log("filteredData",filter)
      filteredData=filter
    }else{
      filteredData=data
    }

    return filteredData
  }
  const [deleteModal , setDeleteModal] = useState(false)

  useEffect(()=>{
    if(deleteModal == true){
      CallDeleteAPi()
    }

  },[deleteModal])

  const CallDeleteAPi = () =>{
    konsole.log("deleteModaldeleteModal",deleteModal)

    setLoader(true)

     let detetedBy = sessionStorage.getItem('loggedUserId')
    let promise = Services.deletePartnerUserDetails(userDataToDelete?.userId, userDataToDelete?.userRgstrtnId, detetedBy)
    promise.then((response)=>{
      message.success("User Deleted Successfully")
      setShowDeleteModal(false)
      setDeleteModal(false)
      getUserListApi()
      konsole.log("deletePartnerUserDetailsRes",response)
    }).catch((error)=>{
      // setLoader(false)
      konsole.log("deletePartnerUserDetailsError",error)
    }).finally(()=>{
      konsole.log("deletePartnerUserDetailsEnd")
      // setLoader(false)
    })}


  const [showDeleteModal , setShowDeleteModal] = useState(false)
  const [userDataToDelete , setUserDataToDelete] = useState()
  const deleteData = (data) =>{
    konsole.log("Clicked", data)
    setUserDataToDelete(data)
    setShowDeleteModal(true)
    // setDeleteModal(true)
  }

  const [updatePartnerUsersData , setUpdatePartnerUsersData] = useState()
  const updatePartnerUsers = (data) =>{
    konsole.log("updatePartnerUsersupdatePartnerUsers", data)
    setUpdatePartnerUsersData(data)
    setVisible(true);
    setshow(!show)


  }

  konsole.log("updatePartnerUsersDataupdatePartnerUsersData",updatePartnerUsersData)

  const confirm = (data) =>{
    setLoader(true)

    let createdBy = sessionStorage.getItem('loggedUserId')
    konsole.log("aaaaaaWorking",createdBy)

    let promise = Services.postSendUserActivationLink(data?.subtenantId, data?.userRgstrtnId, data?.userId, data?.fullName, data?.primaryEmail, data?.userRgstrtnId, createdBy, "::1")
    promise.then((response)=>{
      konsole.log("postSendUserActivationLinkres",response)
      setLoader(false)
      message.success('Link Send Successfully')
    }).catch((error)=>{
      konsole.log("postSendUserActivationLinkerror",error)
      setLoader(false)
    }).finally(()=>{
      konsole.log("postSendUserActivationLinkend")
      setLoader(false)
    })


    // let jsonSendLInk = {
    //   "subtenantId": data?.subtenantId,
    //   "loginUserId": data?.userRgstrtnId,
    //   "userId": data?.userId,
    //   "memberName": data?.fullName,
    //   "emailAddress": data?.primaryEmail,
    //   "signUpPlatform": data?.userRgstrtnId,
    //   "createdBy": createdBy,
    //   "clientIPAddress": "::1"
    // }

    // konsole.log("sendLinkInactive",data, jsonSendLInk)
  }

  const confirms = e => {
    setLoader(true)
    let detetedBy = sessionStorage.getItem('loggedUserId')
    let promise = Services.inActivePartnerUserDetails(e?.userId, e?.userRgstrtnId, detetedBy)
    promise.then((response) => {
      message.success("User deactivate Successfully")
      getUserListApi()
    }).catch((error) => {
      setLoader(false)
    }).finally(() => {
      setLoader(false)
    })
  };
  const cancel = e => {
  };

  const dtHeaderStyle = { color: '#333', fontWeight: 600,fontSize: '14px', background: '#fff',textAlign: 'start',padding:"8px" }
  const dtBodyStyle =  { color: '#333',fontSize: '13px', background: '',textAlign: 'start' ,fontWeight: 100,padding:"8px"}
  const dtBodyStyle2 = { color: '#333',fontSize: '13px', background: '',textAlign: 'center',fontWeight: 100,display:"contents",padding:"8px" }



  return (
    <div className="d-flex flex-column">
      <Form.Provider
        onFormFinish={(name, { values, forms }) => {
          if (name == "userForm") {
            const { basicForm } = forms;

            setVisible(false);
          }
        }}
        className="me-4"
      >
        {/* "fs-4 mb-b" */}
        {/* <Form name="basicForm" onFinish={onFinish}>
          <div className="select-container">
            <p className= {`${roleid==4?'mb-1':'mb-2 mt-2'} fs-4`} style={{marginTop:"5px"}}>
           {(roleid==4) && 'Select a Firm'}
             </p>
             {(roleid !=4) &&   <br />}

            <Row>
              <Select
                placeholder={defaultvalue}
                value={defaultvalue}
                disabled={disabledselect}
                style={{
                  width: "50%"
                }}
                className="fs-5"
                dropdownMatchSelectWidth={false}
                placement={placement}
                onSelect={onSelect}
                // onChange={seletedValue}
              >
                {subtenantdata.map((dataprop) => (
                  <Option
                    value={dataprop.subtenantName}
                    key={dataprop.subtenantId}
                    style={{ margin: "auto", }}
                  >
                    {dataprop.subtenantName}
                  </Option>
                ))}
              </Select>
            </Row>
          </div>
          <Row className="mt-3">
            <Col
              xs={24}
              lg={24}
              span={24}
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Col span={12} style={{ display: "flex" }}>

          <div className="w-100 d-flex" style={{border:"1px solid #333",borderRadius:"5px", justifyContent:"space-between",height:"39px"}}>
              <input
              className="form-control fs-20 newInput"
              style={{border:"none"}}
              type="text"
              placeholder= {`${(roleid==4 )? 'Search for firm user':'Search for staff member'}`}
              onChange={(e) => setSearchevent(e.target.value.toLowerCase())} />
              <img
              style={{padding:"2px",height:"20px",marginTop:"8px", marginRight:"4px"}}
              src="/search icon.png"
              />
              </div>
              </Col>

              <Col>
                <Button
                  htmlType="button"
                  style={{
                    margin: "0 8px",
                    backgroundColor: "#720c20",
                    color: "white",
                    borderRadius: "5px",
                    fontWeight: "600"
                    , height: "40px"
                  }}
                  onClick={showUserModal}
                >
                  <span style={{ fontFamily: "sans-serif" }} status={setFile}>
                    {" "}
                    + ADD NEW USER
                  </span>
                </Button>
              </Col>
            </Col>

           { show ?<AddSubtenantUsers
              visible={visible}
              setshow={setshow}
              onCancel={hideUserModal}
              getUserListApi={getUserListApi}
              selectedSubtenant={selectedSubtenant}
              subtenantValueSelected={subtenantValue}
              setdisableselect={setdisableselect}
              disabledselect={disabledselect}
              updatePartnerUsersData={updatePartnerUsersData}
            />: <></>}

            {
            showRolesModal ? <AddSubtenantNewRoles
              visible={showRolesModal}
                onCancel={hideRolesModalFunc}
              getUserListApi={getUserListApi}
              subtenantValueSelected={subtenantValue}
              selectedSubtenantUser= {selectedSubtenantUser}
            /> : <></>}
            {
              showDeleteModal ? <DeleteConfirmModal visible={showDeleteModal} hideModal={setShowDeleteModal} titleText="Delete User" bodyContent="Do you want to delete this user?" deleteStatus={setDeleteModal} /> : ""
            }
          </Row>
        </Form> */}
      <Form name="basicForm" onFinish={onFinish}>
  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap',marginTop:"1.5rem" }}>

    {/* 1st - Firm Dropdown */}
    {roleid == 4 && (
      <Select
        size="large"
        placeholder={defaultvalue}
        value={subtenantValue || undefined}
        disabled={disabledselect}
        style={{ flex: 1, minWidth: '180px' }}
        dropdownMatchSelectWidth={false}
        placement={placement}
        onSelect={onSelect}
        className="firm-select"
        options={subtenantdata?.map((dataprop) => ({
          value: dataprop.subtenantId,
          label: dataprop.subtenantName,
        }))}
      />
    )}

    {/* 2nd - Search */}
    <div style={{ flex: 2, minWidth: '180px', display: 'flex', border: '1px solid #474747', height: '44px', alignItems: 'center', borderRadius:"2px" }}>
      <img className="ms-2" style={{ padding: '2px', height: '20px', marginRight: '2px',marginLeft: '4px' }} src="/search icon.png" />
      <input
        className="form-control newInput searchBox"
        style={{ border: 'none', outline: 'none', flex: 1, height: '100%', borderRadius:"2px" }}
        type="text"
        placeholder={roleid == 4 ? 'Search for firm user' : 'Search for staff member'}
        onChange={(e) => setSearchevent(e.target.value.toLowerCase())}
      />
    </div>

    {/* 3rd - Button */}
    <Button
      htmlType="button"
      className="add-user-btn"
      size="large"
      style={{fontWeight:'500', height: '44px', whiteSpace: 'nowrap' }}
      onClick={showUserModal}>
    <img className="mt-0 me-2" src="/images/AddPlusBtn.svg" style={{height:"17px", width:"17px"}}/>
      ADD NEW USER
    </Button>

  </div>

  {show && <AddSubtenantUsers
    visible={visible}
    setshow={setshow}
    onCancel={hideUserModal}
    getUserListApi={getUserListApi}
    selectedSubtenant={selectedSubtenant}
    subtenantValueSelected={subtenantValue}
    setdisableselect={setdisableselect}
    disabledselect={disabledselect}
    updatePartnerUsersData={updatePartnerUsersData}
  />}

  {showRolesModal && <AddSubtenantNewRoles
    visible={showRolesModal}
    onCancel={hideRolesModalFunc}
    getUserListApi={getUserListApi}
    subtenantValueSelected={subtenantValue}
    selectedSubtenantUser={selectedSubtenantUser}
  />}

  {showDeleteModal && <DeleteConfirmModal
    visible={showDeleteModal}
    hideModal={setShowDeleteModal}
    titleText="Delete User"
    bodyContent="Do you want to delete this user?"
    deleteStatus={setDeleteModal}
  />}
</Form>
      </Form.Provider>

      {deactivateModalVisible && <DeleteConfirmModal
        visible={deactivateModalVisible}
        hideModal={setDeactivateModalVisible}
        titleText="Deactivate User"
        bodyContent="Do you want to deactivate this staff member?"
        yesButtonText="Yes"
        noButtonText="No"
        onYes={() => {
          confirms(selectedUser);
          setDeactivateModalVisible(false);
        }}
        onNo={() => setDeactivateModalVisible(false)}
      />}

      {resendInviteModalVisible && <DeleteConfirmModal
                  visible={resendInviteModalVisible}
                  hideModal={setResendInviteModalVisible}
                  titleText="Resend Invite Link"
                  bodyContent="Do you want to resend the invite link?"
                  yesButtonText="Yes"
                  noButtonText="No"
                  onYes={() => {
                    confirm(selectedUser);
                    setResendInviteModalVisible(false);
                  }}
                  onNo={() => setResendInviteModalVisible(false)}
                />}


      <div style={{ border: '1px solid #ddd', marginTop: '12px', display: 'flex', flexDirection: 'column' }}>
        <div style={{ maxHeight: 'calc(100vh - 240px)', overflowY: 'auto', overflowX: 'auto' }}>
          <table className="table table-bordered mb-0 staff-table custom-striped-table" style={{ fontFamily: "Open Sans, sans-serif", fontSize: '13px' }}>
            <thead style={{ position: 'sticky', top: -1, zIndex: 1, background: '#fff' }}>
              <tr>
                <th style={dtHeaderStyle}>Actions</th>
                <th style={{...dtHeaderStyle, cursor: 'pointer' }} onClick={() => handleSort('isActive')}>Status {sortIcon('isActive')}</th>
                <th style={{ ...dtHeaderStyle, cursor: 'pointer' }} onClick={() => handleSort('fullName')}>
                  Name {sortIcon('fullName')}
                </th>
                <th style={{ ...dtHeaderStyle, cursor: 'pointer' }} onClick={() => handleSort('primaryEmail')}>
                  Email {sortIcon('primaryEmail')}
                </th>
                <th style={{ ...dtHeaderStyle, cursor: 'pointer' }} onClick={() => handleSort('primaryMobile')}>
                  Phone Number {sortIcon('primaryMobile')}
                </th>
                <th style={dtHeaderStyle}>Role</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData(getSortedData(searchonchange(data)))?.length > 0
                ? paginatedData(getSortedData(searchonchange(data))).map((record, index) => (
                  <tr key={record.userId}>
                    <td style={dtBodyStyle2}>
                      <div style={{ display: 'flex', justifyContent: "space-evenly", alignItems: 'start' }}>
                        <Tooltip title="Click here to edit staff details">
                          <EditOutlined style={{ color: '#4a90d9', fontSize: '16px', cursor: 'pointer', marginTop:"2px" }} onClick={() => updatePartnerUsers(record)} />
                        </Tooltip>
                        <Tooltip title="Click to delete">
                          {/* <DeleteOutlined style={{ color: '#e24b4a', fontSize: '16px', cursor: 'pointer' }} onClick={() => deleteData(record)} /> */}
                          <img src="/icons/delete-Icon_Option.svg" style={{ width: '16px', height: '16px', cursor: 'pointer', verticalAlign: 'middle',marginTop:"0px" }} onClick={() => deleteData(record)} />
                        </Tooltip>
                        <Tooltip title="Click to assign or revoke staff role">
                          <UserOutlined style={{ fontSize: '16px', cursor: 'pointer', marginTop:"2px" }} onClick={() => showRolesModalFunc(record)} />
                        </Tooltip>
                      </div>
                    </td>
                    {record.isActive ? (
                        <td style={dtBodyStyle}>
                        <Tooltip title="Click to activate or deactivate staff" placement="top" align={{ offset: [0, 7] }}>
                          <span
                            onClick={() => openDeactivateModal(record)}
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '6px',
                              cursor: 'pointer',
                              border: '1.5px solid #52c41a',
                              borderRadius: '6px',
                              padding: '2px 10px',
                              background: '#F3F8F5',
                              color: '#15803D',
                              fontWeight: 500,
                              fontSize: '12px',
                              whiteSpace: 'nowrap',
                              minWidth:"80px"
                            }}
                          >
                            <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#15803D', display: 'inline-block', flexShrink: 0 }} />
                            Active
                          </span>
                        </Tooltip>
                        </td>
                    ) : (
                        <td style={dtBodyStyle}>
                        <Tooltip title="Click to activate or deactivate staff"
                        placement="top" align={{ offset: [0, 7] }}
                      getPopupContainer={(trigger) => trigger.parentElement} >
                          <span
                            onClick={() => openResendInviteModal(record)}
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '6px',
                              cursor: 'pointer',
                              border: '1.5px solid #adb5bd',
                              borderRadius: '6px',
                              padding: '2px 10px',
                              background: '#f1f3f5',
                              color: '#495260',
                              fontWeight: 500,
                              fontSize: '12px',
                              whiteSpace: 'nowrap',
                              minWidth:"80px"
                            }}
                          >
                            <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#495260', display: 'inline-block', flexShrink: 0 }} />
                            Inactive
                          </span>
                        </Tooltip>
                        </td>
                    )}
                   <td style={dtBodyStyle}>
                  <Tooltip title="Click here to edit staff details" placement="top" align={{ offset: [0, 8] }}>
                    <span style={{ color: '#333', fontWeight: 500, cursor: 'pointer', display: "inline-block" }} onClick={() => updatePartnerUsers(record)}>
                      {record.fullName}
                    </span>
                  </Tooltip>
                </td>
                    <td style={dtBodyStyle}>{record?.primaryEmail}</td>
                    <td style={dtBodyStyle}>{formatPhoneNumberWithoutCntryCode(record?.primaryMobile) || '-'}</td>
                    <td style={{...dtBodyStyle2, cursor:"pointer" }}>
                      <Tooltip  title={roleid != 4 && record?.roleKey} align={{ offset: [0, 7] }}>
                        <span style={dtBodyStyle}>
                          {roleid == 4 ? "Firm Administrator" : record?.roleKey
                            ? record.roleKey.split(',').slice(0, 2).join(', ') + (record.roleKey.split(',').length > 2 ? '...' : '')
                            : '-'}
                        </span>
                      </Tooltip>
                    </td>
                  </tr>
                ))
                : <tr><td colSpan={6} style={{ textAlign: 'center', padding: '20px', color: '#777' }}>No matching records found.</td></tr>
              }
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px', borderTop: '1px solid #ddd', background: '#fff' }}>
          <span style={{ fontSize: '13px', color: '#555' }}>
            Showing {Math.min((currentPage - 1) * pageSize + 1, getSortedData(searchonchange(data))?.length)} to {Math.min(currentPage * pageSize, getSortedData(searchonchange(data)).length)} of {getSortedData(searchonchange(data))?.length} entries
          </span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>


            <button onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1}
              style={{ width: '28px', height: '28px', border: '1px solid #474747', borderRadius: '4px', background: '#fff', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', color: '#555' }}>‹</button>

            {(() => {
              const total = totalPages(getSortedData(searchonchange(data)));
              const pages = [];
              for (let p = 1; p <= total; p++) {
                if (p === 1 || p === total || (p >= currentPage - 1 && p <= currentPage + 1)) {
                  pages.push(p);
                }
              }
              const result = [];
              pages.forEach((p, i) => {
                if (i > 0 && p - pages[i - 1] > 1) result.push('ellipsis-' + p);
                result.push(p);
              });
              return result.map((p, i) =>
                String(p).startsWith('ellipsis')
                  ? <span key={p} style={{ padding: '0 4px', fontSize: '13px' }}>...</span>
                  : <button key={p} onClick={() => setCurrentPage(p)}
                    style={{
                      width: '28px', height: '28px', border: '1px solid #474747', borderRadius: '4px',
                      background: currentPage === p ? '#720c20' : '#fff',
                      color: currentPage === p ? '#fff' : '#555',
                      cursor: 'pointer', fontSize: '13px'
                    }}>
                    {p}
                  </button>
              );
            })()}

            <button onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages(getSortedData(searchonchange(data)))))} disabled={currentPage === totalPages(getSortedData(searchonchange(data)))}
              style={{ width: '28px', height: '28px', border: '1px solid #474747', borderRadius: '4px', background: '#fff', cursor: currentPage === totalPages(getSortedData(searchonchange(data))) ? 'not-allowed' : 'pointer', color: '#555' }}>›</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubtenantTable;
